module.exports = __webpack_public_path__ + "static/phone-slide-4-en-c6a3b87adc54bfc794f8f6786abe0c71.png";